import { Directive, effect, inject } from '@angular/core';
import { IonDatetime } from '@ionic/angular';
import { select } from '@ngxs/store';
import { LocalizationState } from '../state/localization.state';

/**
 * `wilsonUseLocalizedIonDatetime` directive
 *
 * Binds `locale` on Ionic `ion-datetime` from `LocalizationState.getLocale` so
 * templates do not need `[locale]` / `locale="..."`.
 *
 * Usage:
 * ```html
 * <ion-datetime wilsonUseLocalizedIonDatetime [max]="max" ...></ion-datetime>
 * ```
 *
 * Do not set `locale` or `[locale]` when using this directive.
 * Enforcement: `@wilson/require-ion-datetime-defaults` ESLint rule.
 */
@Directive({
  selector: 'ion-datetime[wilsonUseLocalizedIonDatetime]',
  standalone: true,
})
export class UseLocalizedIonDatetimeDirective {
  private readonly ionDatetime = inject(IonDatetime);
  private readonly locale = select(LocalizationState.getLocale);

  constructor() {
    effect(() => {
      this.ionDatetime.locale = this.locale();
    });
  }
}
